/** Keep internal coding commands and audit metadata out of the review card. */
export function proposalDisplayValue(fieldId: string, value: string): string {
  if (!fieldId.endsWith('.meddra_coding') || !value) return value;
  try {
    const coding = JSON.parse(value);
    if (coding.action === 'clear' || coding.status === 'cleared') return 'Coding cleared';
    const name = coding.term?.name || coding.raw?.lower_level_term || coding.raw?.llt || coding.raw?.disease_coded_term;
    const code = coding.lltCode || coding.raw?.lower_level_term_code || coding.raw?.code || coding.raw?.event_code;
    return [name, code && `Code ${code}`, coding.version && `MedDRA ${coding.version}`]
      .filter(Boolean).join(' · ') || 'Unverified coding';
  } catch { return 'Unverified coding'; }
}
